import { Injectable } from '@angular/core';
import { ClaimKeys } from 'src/app/helpers/claimkeys.class';

@Injectable({
  providedIn: 'root'
})
export class LocalStorageService {
  public claimKeys = new ClaimKeys();
  public set(name: string, item: any) {
    localStorage.setItem(name, JSON.stringify(item));
  }
  public get(name: string) {
    return JSON.parse(localStorage.getItem(name));
  }

  public remove(name: string) {
    localStorage.removeItem(name);
  }

  public checkClaim(claim: string) {
    return this.get('ussr').Claims.includes(claim); //true;
  }
  private getUserClaims(): string[] {
    return JSON.parse(localStorage.getItem('Claim') || '[]');
  }
}
